<template>
  <div>
    <BaseFrame @submit='passReviewModal=true' @clear='handleClear' cancelText='' clearText='驳回'
      submitText='通过' :showCtrls='true' :id='prescriptionId' idText='处方编号' :infosArr='infosArr'>
      <div slot="content">
        <lk-card title="处方药品订单信息">
          <div class="printContainer" id="pic">
            <lk-button class="uploader" @click="replaceModal=true" v-if="isApplet">
              编辑图片
            </lk-button>
            <div class="replaceCon">
            <img ref="pic" class='stamp' :src="currentImg" alt="" v-if="currentImg">
            <div class="preCon" v-if="currentImg">
              <div>该处方已过期或已使用，您可以联系患者再次提供有效处方，或者驳回处方单！</div>
              <lk-button  @click="openModal">
                关联电子处方
              </lk-button>
            </div>
            </div>
            <lk-Page :current="pageData.current" :page-size="1" :total="pageData.total" v-if="currentImg" simple @on-change="changePage"  class="image-page"/>
            <ReplaceImg
              v-model="newCurrentList"
              :replaceModal.sync='replaceModal'
              :currentImg.sync='currentImg'
              :epId="epId"
            >
            </ReplaceImg>
          </div>
        </lk-card>
        <lk-modal v-model="passReviewModal" title='同意'>
          <div class="modalContainer">
            <h2>您确定要同意该处方审核通过吗？</h2>
            <lk-form :model='passReview' :rules='passValidate' ref="passForm">
              <lk-form-item prop='prescriptionSignTime'>
                <timeStampDatePicker :options='options' clearable v-model="passReview.prescriptionSignTime" :placeholder='"请录入该处方开方时间"'>
                </timeStampDatePicker>
              </lk-form-item>
            </lk-form>
          </div>
          <div slot="footer" class="footerBtns">
            <lk-button @click='passReviewModal=false'>取消</lk-button>
            <lk-button type='primary' @click='passSubmit' :loading='submitLoading'>同意</lk-button>
          </div>
        </lk-modal>
        <lk-modal v-model="refuseModal" title='驳回原因'>
          <div>
            <div class="refuseContainer">
              <span>驳回原因</span>
            <lk-form :model='refuse' :rules='passValidate' ref="refuseForm">
              <lk-form-item prop='prescriptionRejectionReason' style="width: 200px;">
                <lk-select v-model="refuse.prescriptionRejectionReason" @on-change="selectChange">
                  <lk-option v-for="(item,i) in prescriptionRejectionReasonList" :key='i' :value='i'>
                    {{item}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-form>
            </div>
            <div>
              <div>备注</div>
              <div>
                <lk-input type='textarea' :maxlength='100' v-model="refuse.prescriptionRejectionMark"></lk-input>
              </div>
            </div>
          </div>
          <div slot="footer">
            <lk-button @click='refuseModal=false'>取消</lk-button>
            <lk-button type='primary' @click='refuseSubmit' :loading='submitLoading'>拒绝</lk-button>
          </div>
        </lk-modal>
        <!-- 来源为小程序预约时，药店员工点击驳回时，弹出温馨提示弹窗： -->
        <lk-modal v-model="reminderModal" title='温馨提示' v-if="isApplet">
          <div class="modalContainer">
            <span>{{text}}</span>
          </div>
          <div slot="footer" class="footerBtns">
            <lk-button @click='reminderModal=false'>取消</lk-button>
            <lk-button type='primary' @click='handlerReminder' :loading='submitLoading'>确定驳回</lk-button>
          </div>
        </lk-modal>
        <lk-modal
          v-model="modalPre"
          :footer-hide='true'
          title="关联电子处方">
          <lk-form :model='preInfo' :rules='preInfoRules' :label-width="80" ref="preInfoForm" v-if="modalPre">
            <lk-form-item label='互联网医院:'>
              <span>银川零氪互联网医院</span>
            </lk-form-item>
            <lk-form-item label='处方单号:' prop='code'>
              <lk-input :maxlength='20' placeholder='请输入处方单号' v-model="preInfo.code "></lk-input>
            </lk-form-item>
            <lk-form-item label='患者姓名:' prop="patientName">
              <lk-input :maxlength='20' placeholder='请输入患者姓名' v-model="preInfo.patientName"></lk-input>
            </lk-form-item>
          </lk-form>
          <div class="btnCon">
            <lk-button size='small' type='primary' @click='toConnect' :disabled='btnConnectSta'>查询</lk-button>
            <lk-button size='small' @click='toCancel' style="margin-left:10px">取消</lk-button>
          </div>
        </lk-modal>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import goods from '../../services/goods'
import ReplaceImg from '../../components/prescription/replaceImg.vue';

export default {
  name: 'prescriptionAudit',
  components: {
    BaseFrame,
    ReplaceImg,
  },
  computed: {
    text() {
      const time = new Date(this.info.ep.createTime).getTime();
      if (new Date().getTime() - time > 1000 * 60 * 60 * 24 * 365) {
        return '驳回后，该笔订单将关闭，交易时间超过一年的订单无法微信原路退款，请联系患者进行线下退款。';
      }
      return '驳回后，该笔订单将关闭，如果患者已线上支付，则原路返回退款！';
    },
  },
  watch: {
    newCurrentList: {
      handler(val) {
        this.currentList = val;
      },
    },
  },
  data() {
    return {
      btnConnectSta: false,
      modalPre: false,
      preInfo: {
        code: null,
        patientName: null
      },
      preInfoRules: {
        code: [
          {
            required: true,
            message: '请输入处方单号',
            trigger: 'change'
          }
        ],
        patientName: [
          {
            required: true,
            message: '请输入患者姓名',
            trigger: 'change'
          }
        ]
      },
      options: {
        disabledDate: utils.forbiddenDate.disabledFromToday,
      },
      pageData: {
        current: 1,
        total: 5,
      },
      reminderModal: false, // 温馨提示
      replaceModal: false, // 替换处方modal
      newCurrentList: [], // 新返回的img数组
      isApplet: false, // 是否是小程序预约
      epId: null,
      canRefuse: '',
      currentList: [],
      currentImg: '',
      prescriptionId: '',
      submitLoading: false,
      passReviewModal: false,
      passValidate: {
        prescriptionSignTime: [
          {
            required: true, message: '请录入该处方开方日期', trigger: 'change', type: 'number',
          },
        ],
        prescriptionRejectionReason: [
          {
            required: true, message: '请选择驳回原因', trigger: 'change',
          },
        ],
      },
      refuseModal: false,
      passReview: {},
      refuse: {},
      infosArr: [],
      info: {
        ep: {},
      },
      prescriptionRejectionReasonList: {
        1: '不规范处方',
        2: '不适宜处方',
        3: '超常处方',
      },
      list: [], // 存储基础商品id
    };
  },
  methods: {
    toCancel() {
      this.modalPre = false;
    },
    toConnect() {
      const params = {
        code: this.preInfo.code,
        patientName: this.preInfo.patientName,
        detailList: this.list,
        epId: this.$route.params.id
      }
      this.$refs.preInfoForm.validate((valid) => {
        if (valid) {
          goods.getElectronicInfoByCode(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('查询成功');
              this.modalPre = false;
            } else {
              this.$Modal.warning({
                title: '温馨提示',
                content: `<p>${res.data.error}</p>`,
                okText: '我知道了',
              });
            }
          }).catch((err) => {
            utils.handleError(err);
          })
        }
      })
    },
    openModal() {
      this.modalPre = true;
    },
    handleClear() {
      // 判断是不是小程序预约的sourceType = 8;
      const sourceType = this.info.ep.sourceType;
      sourceType === 8 ? this.reminderModal = true : this.refuseModal = true;
    },
    handlerReminder() {
      this.reminderModal = false;
      this.refuseModal = true;
    },
    passSubmit() {
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          this.passReview.epId = this.info.ep.id;
          sale.prescriptionPassReview(this.passReview).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('同意成功');
              this.$router.push({ name: 'prescriptionList' });
            } else {
              this.$Message.error(res.data.error);
            }
            this.passReviewModal = false;
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    selectChange() {
      this.canRefuse = false;
    },
    refuseSubmit() {
      this.$refs.refuseForm.validate((valid) => {
        if (valid) {
          this.refuse.epId = this.info.ep.id;
          sale.prescriptionUnPassReview(this.refuse).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('驳回成功');
              this.$router.push({ name: 'prescriptionList' });
            } else {
              this.$Message.error(res.data.error);
            }
            this.refuseModal = false;
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    changePage(e) {
      this.currentImg = this.currentList[e - 1];
    },
    getData(epId) {
      sale.getPrescriptiondDetail({
        epId,
      }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          const { ep } = data;
          if (data.epDetailVoList.length) {
            data.epDetailVoList.forEach((item) => {
              if (item.isRx === 1) {
                let num = item.epDetail.num || '';
                this.list.push({ num, goodsBaseId: item.goodsBaseId});
              }
            })
          }
          this.isApplet = ep.sourceType === 8 ? true : false;
          this.info = data;
          const imgList = [];
          if (this.info.ep.picUrls) {
            this.currentImg = decodeURIComponent(this.info.ep.picUrls[0]);
            this.info.ep.picUrls.forEach((item) => {
              imgList.push(decodeURIComponent(item));
            });
          }
          this.currentList = imgList;
          this.pageData.total = imgList.length;
          this.prescriptionId = ep.prescriptionNo;
          this.infosArr = [
            { name: '订单时间：', value: utils.exchangeTime(ep.createTime) },
            { name: '处方来源：', value: ep.sourceTypeName },
            { name: '患者姓名：', value: ep.patientName },
          ];
          if (this.isApplet) {
            const appletArr = [
              { name: '下单人联系方式：', value: ep.consigneePhone },
              { name: '患者联系方式：', value: ep.patientPhone },
            ];
            this.infosArr.push(...appletArr);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    const { id } = this.$route.params;
    this.epId = Number(id);
    this.getData(id);
  },
};

</script>
<style lang="less" scoped>
.printContainer{
  width:100%;
  .replaceCon {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    position: relative;
  }
  img{
    display:block;
    margin: 0 auto;
    width: 800px;
  }
  .uploader {
    width: 80px;
    position: absolute;
    top: 1px;
    left: 92px;
    background: #2d8cf0;
    color: #fff;
  }
}
.footerBtns{
  text-align:center
}
.refuseContainer{
  display: flex;
  align-items: center;
  span:first-child{
    width: 70px;
  }
}
.image-page {
  margin-top: 10px;
 display: flex;
 justify-content: center;
}
.canRefuse {
  margin-left: 60px;
  color: red;
  padding: 5px;
}
.preCon {
  width: 100px;
  height: 200px;
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  top: 10%;
  right: -50px;
}
.btnCon {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
